import React from "react";
import LanguageInput from "./LanguageInput";
import PropTypes from "prop-types";
import { ArrayInput, SimpleFormIterator, TextInput, required, useTranslate } from "react-admin";

const validateRequired = [required()];

const LabelArrayInput = ({ source, ...props }) => {
    const translate = useTranslate();

    return (
        <ArrayInput
            fullWidth
            source={source}
            {...props}
        >
            <SimpleFormIterator>
                <LanguageInput
                    label={translate("product.label.language")}
                    source="lang"
                    validate={validateRequired}
                />
                <TextInput
                    fullWidth
                    label={translate("product.label.label")}
                    multiline
                    resettable
                    source="label"
                    validate={validateRequired}
                />
            </SimpleFormIterator>
        </ArrayInput>
    );
};

LabelArrayInput.propTypes = {
    source: PropTypes.string.isRequired,
};

export default LabelArrayInput;
